import { useMemo } from "react";
import { getAddressText } from "@b2bportal/core-utilities";
import type { HotelShopMapComponentProps } from "./HotelShopMap";

export const useHotelShopMap = ({ hotel }: HotelShopMapComponentProps) => {
  return useMemo(() => {
    return {
      context: {
        coordinates: hotel.lodging.location.coordinates,
        //Google static maps requires hex colors to start with 0x
        markerIcon:
          "https://cdn.hopper.com/b2bportal/perkspot/images/icons/StaticMapPin.png",
      },
      text: {
        hotelName: hotel.lodging.name,
        address: getAddressText(hotel.lodging.address),
      },
    };
  }, [hotel]);
};
